module.exports = __webpack_public_path__ + "img/picto-comment4x.e1bcb9e1.png";